import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
// tslint:disable-next-line:import-blacklist
import 'rxjs/Rx';
import { LocalStorage } from '@ngx-pwa/local-storage';
import { NgxRolesService, NgxPermissionsService } from 'ngx-permissions';
import { User } from '../../models/user.model';
import { environment } from '../../../environments/environment';

@Injectable()
export class AuthUserService {
    private _promise: Promise<any>;
    private _promiseDone = false;
    public _user: User;
    public _location : Location;

    constructor(private http: HttpClient, private localStorage: LocalStorage,
        private rolesService: NgxRolesService, private permissionsService: NgxPermissionsService) { }

    getAuthUser(): Promise<any> {
        // const userEndPoint = 'http://localhost:58830/api/User/GetUser';
        const userEndPoint = environment.apiEndpoint + '/User/GetUser';
        this._promise = this.http
        .get(userEndPoint)
        .map((resp: Response) => resp).do(d => {})
        .toPromise()
        .then((data: any) => {
           // console.log(data);

            // store User data in class variable & async local storage
            this._user = data;
            this.localStorage.setItem('user', data).subscribe();
            this._location = data;
            this.localStorage.setItem('location', data);    // TODO is this needed? not subscribing, so location data is
                                                            // never added to localstorage anyway.
            // add User's Roles and Permissions
            // UserRoles & UserType for ngxRoles
            // UserStatus for ngxPermissions -- New, Registered, Activated, Deactivated
            this.permissionsService.addPermission(data.userStatus.statusName);
            this.rolesService.addRole(data.userType.typeName, [data.userStatus.statusName]);
            data.userRoles.forEach(element => {
                this.rolesService.addRole(element.roleName, [data.userStatus.statusName]);
            });

            this._promiseDone = true;

        }).catch((err: any) => {
            this._promiseDone = true;
            return Promise.resolve();
        });
        return this._promise;
    }

    updateAuthUser(user: User) {
        this._user = user;
    }

    set AuthUser (user: User) {
        this._user = user;
    }

    // TODO
    // Components should access _user property
    // through getter & make _user property private
    get AuthUser() {
        return this._user;
    }
}




// WEBPACK FOOTER //
// ./src/app/services/appInitialization/authUser.service.ts